import { Trans, useLingui } from '@lingui/react/macro';

import type { Appointment } from '../../../react-query/useAppointments';
import type { Task } from '../../../react-query/useGetTasks';
import { GamifiedTask } from '../patientStrip/recommendedActions/gamifiedTask';

import { useDisplayTasks } from './hooks';

interface Props {
  appointment: Appointment;
  tasks: Task[];
}

export const RecommendationsCellTasks = ({ appointment, tasks }: Props) => {
  const { i18n } = useLingui();
  const { gamifiedTasks } = useDisplayTasks(appointment, tasks);

  return (
    <>
      {gamifiedTasks.map(({ task, lastTreatmentDate }) => (
        <div key={task.type}>
          <GamifiedTask disabled isBlackAndWhite key={task.type} task={task} />

          {task.status !== 'NOT_SUGGESTED' && !!lastTreatmentDate && (
            <p className="vai-typography-small !vai-ml-7">
              (<Trans>last </Trans>
              {i18n.date(new Date(lastTreatmentDate), {})})
            </p>
          )}
        </div>
      ))}
    </>
  );
};
